import { useSession } from '@sdk/session/SessionContext';
import { hasAccessToUser } from '@sdk/personaCollection/utils/personaCollection.utils';
import { User } from '@sdk/users/types/User';
import { DisplayTextProps } from '@sdk/components/ui/DisplayTextStyle';

import { useNavigation } from '@web/navigation/NavigationProvider';
import { NameLink } from '@web/components/UserNameLink/userNameLink.styles';

type Props = {
  user: User;
} & DisplayTextProps;

export const UserNameLink = ({ user, ...textProps }: Props) => {
  const { navigate } = useNavigation();
  const { currentUser } = useSession();
  const canNavigate = !user.deleted && hasAccessToUser(currentUser, user);

  return (
    <NameLink
      onClick={() => navigate('users.profile', { userId: user.id })}
      canNavigate={canNavigate}
      {...textProps}>
      {user.fullname}
    </NameLink>
  );
};
